import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AppShell from "@/pages/AppShell";
import Dashboard from "@/pages/Dashboard";
import Mechanics from "@/pages/Mechanics";
import MechanicDetail from "@/pages/MechanicDetail";
import Simulator from "@/pages/Simulator";
import Diagnostics from "@/pages/Diagnostics";
import Repairs from "@/pages/Repairs";
import Lessons from "@/pages/Lessons";
import Rewards from "@/pages/Rewards";
import Vehicles from "@/pages/Vehicles";
import VehicleDetail from "@/pages/VehicleDetail";

function Protected() {
  const token = localStorage.getItem("gs_token");
  if (!token) return <Navigate to="/login" replace />;
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<Protected />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/mechanics" element={<Mechanics />} />
          <Route path="/mechanics/:id" element={<MechanicDetail />} />
          <Route path="/simulator" element={<Simulator />} />
          <Route path="/diagnostics" element={<Diagnostics />} />
          <Route path="/repairs" element={<Repairs />} />
          <Route path="/lessons" element={<Lessons />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/vehicles" element={<Vehicles />} />
          <Route path="/vehicles/:car_number" element={<VehicleDetail />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
